import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography
} from "@mui/material";
import { observer } from "mobx-react-lite";
import DialogContentText from "@mui/material/DialogContentText";

import { RootStoreContext } from "../store/root";

const DeleteDialog = (props) => {
  const rootStore = useContext(RootStoreContext);
  const { rowDelete, setRowDelete } = rootStore.deleteStore;

  /* UseStates */
  const [message, setMessage] = useState(undefined);
  /* End UseStates */

  useEffect(() => {

    const mensaje =
      `¿Seguro que quiere eliminar ${props.FieldName} ${rowDelete?.NameRow}?` +
      ` ${rowDelete?.MessageWhenDelete}`;
    setMessage(mensaje);
  }, [rowDelete]);

  useEffect(() => {
    return () => {
      setRowDelete(undefined);
    };
  }, []);

  /* Methods */
  /* End Methods */

  return (
    <Dialog
      open={props.Open}
      onClose={props.OnClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {`Eliminar ${props.FieldName}`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography variant="message">{message}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.OnClose} variant="contained" color="secondary" sx={{color: '#fff'}}>CANCELAR</Button>
        <Button
          onClick={() => {
            props.OnFinish();
          }}
          autoFocus
          variant="contained"
        >
          ACEPTAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default observer(DeleteDialog);
